import axios from 'axios'
import moment from 'moment'
import toast from 'react-hot-toast'
import create, { GetState, SetState } from 'zustand'
import { Axios } from '../utils/axios'
import { handleAxiosError } from '../utils/error'
import useBVNStore from './BVN.store'

type MotorState = {
  loading: boolean
  setLoading: (loading: boolean) => void
  fetchNiid: (plate: string) => void
  vehicleDetails?: any
  setVehicleDetails: (loading: any) => void
  onboardBuyPolicy: () => void
  screen?: string
  setScreen: (loading: any) => void
  setYear: (loading: any) => void
  policy?: any
  user_id?: number
  policy_id?: number
  paymentDetails?: any
  policy_number?: any
  plate?: string
  generateAccount: any
  renewPolicy: (policy_id?: string, user_id?: any, policy?: any) => any
  confirmPayment: any
  resendPolicy: any
  errorMessage: string
  setErrorMsg: any
}

const defaultState = {
  loading: false,
  errorMessage: '',
  screen: 'ENTER_PLATE'
}

const MotorStore = (set: SetState<MotorState>, get: GetState<MotorState>) => ({
  ...defaultState,
  setScreen: (screen: string) => {
    set({ screen })
  },
  reset: () => {
    set(defaultState)
  },
  fetchNiid: async (plate: string) => {
    set({ loading: true, plate })
    try {
      const { data: response } = await Axios.get(`products?policy_type=vehicle`)
      const { data } = await Axios.get(`policy/vehicle/verify-plate-number?plate_number=${plate}`)
      set({ loading: false, vehicleDetails: data.data, policy: response.data.products[0] })
    } catch (error: any) {
      set({ loading: false })
      throw Error
      // handleAxiosError(error)
    }
  },
  onboardBuyPolicy: async () => {
    const { vehicleDetails, policy } = get()
    const { bvn, email, BVNdetails } = useBVNStore.getState()
    set({ loading: true })
    try {
      const body = {
        user_data: {
          first_name: BVNdetails.first_name,
          last_name: BVNdetails.last_name,
          middle_name: BVNdetails.middle_name,
          dob: moment(BVNdetails.dob).format('YYYY-MM-DD'),
          email,
          bvn,
          phone_number: BVNdetails.phone_number,
          gender: BVNdetails.gender.charAt(0)
        },
        vehicle_data: {
          type: vehicleDetails.type || 'Vehicle',
          make: vehicleDetails.make,
          license_number: vehicleDetails.plate_number,
          color: vehicleDetails.color || 'Custom',
          model: vehicleDetails.model,
          vin_number: vehicleDetails.chasis_number,
          type_of_use: 'PRIVATE',
          year: vehicleDetails.year
        },
        product_id: String(policy.id)
      }

      const { data } = await Axios.post(`policy/vehicle/onboard`, body)

      set({
        loading: false,
        user_id: data.data.user_id,
        policy_id: data.data.id,
        policy_number: data.data.policy_number
      })
    } catch (error: any) {
      if (error?.response?.data?.message.includes('to complete')) {
        set({ loading: false, errorMessage: error?.response?.data?.message })
        return
      }
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  setErrorMsg: () => {
    set({ errorMessage: '' })
  },
  buyPolicy: async (plate?: string, id?: string) => {
    let { vehicleDetails } = get()
    const { policy } = get()
    set({ loading: true })
    if (plate) {
      const { data } = await Axios.get(`policy/vehicle/verify-plate-number?plate_number=${plate}`)
      vehicleDetails = data.data
    }
    try {
      const body = {
        vehicle_data: {
          type: vehicleDetails.type || 'Vehicle',
          make: vehicleDetails.make,
          license_number: vehicleDetails.plate_number,
          color: vehicleDetails.color || 'Custom',
          model: vehicleDetails.model,
          vin_number: vehicleDetails.chasis_number,
          type_of_use: 'PRIVATE'
        },
        product_id: id || String(policy.id)
      }

      const { data } = await Axios.post(`policy/vehicle`, body)

      set({
        loading: false,
        user_id: data.data.user_id,
        policy_id: data.data.id,
        policy_number: data.data.policy_number
      })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  generateAccount: async (policy_id?: any, user_id?: any) => {
    if (!policy_id || !user_id) {
      policy_id = get().policy_id
      user_id = get().user_id
    }
    set({ loading: true })
    try {
      const { data } = await Axios.post(`vnuban`, { user_id, policy_id: String(policy_id) })
      set({ loading: false, paymentDetails: data.data })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  resendPolicy: async (policy_id?: any) => {
    set({ loading: true })
    try {
      await Axios.get(`policy/doc/${policy_id}`)
      set({ loading: false })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  renewPolicy: async (policy_id?: string, user_id?: any, policy?: any) => {
    set({ loading: true })
    try {
      const response = await Axios.post(`policy/${policy}/renew`, { policy_id })
      const { data } = await Axios.post(`vnuban`, {
        user_id,
        policy_id: String(response.data.data.id)
      })
      set({ loading: false, paymentDetails: data.data })
      return true
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  confirmPayment: async (ref: string) => {
    set({ loading: true })
    try {
      const { data } = await Axios.get(`vnuban/verify-transaction?reference=${ref}`)
      set({ loading: false })
      console.log(data.message)
      return data.message
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  setLoading(loading: boolean) {
    set({ loading })
  },
  setYear(year: string) {
    const { vehicleDetails } = get()
    set({ vehicleDetails: { ...vehicleDetails, year } })
  },
  setVehicleDetails: async (vehicleDetails: any) => {
    set({ loading: true })
    try {
      const { data: response } = await Axios.get(`products?id=1`)
      set({ vehicleDetails, policy: response.data.products[0] })
      set({ loading: false })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  }
})

// const useMotorStore = create(
//   persist<MotorState>(MotorStore, {
//     name: 'motor-store'
//   })
// )

const useMotorStore = create<MotorState>(MotorStore)

export default useMotorStore
